import { BehaviorSubject } from 'rxjs';

export class FilterableService extends BehaviorSubject<any[]> {
    filteredData: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
    loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    length: number;
    minimumFilterLength = 0;
    private checkCount = 0;

    constructor(data: any[] = []) {
        super(data);
        this.subscribe(x => this.resetFilter());
    }

    /**
     *
     */
    resetFilter() {
        try {
            this.checkCount = 0;
            this.length = this.value.length;
            this.updateFilteredData();
        } catch (e) { }
    }


    updateFilteredData(data: any[] = this.value) {
        if (this.checkCount >= this.minimumFilterLength) {
            this.filteredData.next(data);
        }
    }


    /**
     *
     */
    handleFilter(check: string, field?: string, selected: any[] = []): void {
        let result: any[] = this.value;
        try {
            if (check && check !== '') {
                this.checkCount = this.checkCount + 1;
                result = this.value.filter(x => {
                    const source: string = field ? x[field].toString() : this.getDataValue(x);
                    return source.toLowerCase().indexOf(check.toLowerCase()) !== -1;
                });
            }
        } catch (e) { }

        if (check && check !== '' && selected instanceof Array) {
            result = result.filter(x => !selected.some(s => {
                const source = x.Id || x;
                return source === s.Id || s;
            }));
        }
        this.updateFilteredData(result);
    }

    private getDataValue(value): string {
        if (typeof value === 'object') {
            return Object.keys(value).map(x => value[x]).join();
        } else {
            return value.toString();
        }
    }

}
